// @flow
import React from 'react';

import { camelCasify } from 'Components/utils/string/string.util';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TeaserCards } from 'Components/widgets/teaser-cards/TeaserCards';

type Props = {|
  cards: Array<{
    image: string,
    title: string,
    subtitle?: string,
    seeMoreLabel: string,
    seeMoreUrl: string,
    layerTitle: string,
    layerDescription: string,
    layerBlocks: Array<{
      title: string,
      text: string,
    }>,
  }>,
  config: CMSContent,
  header: string,
  id: string,
  title: string,
|};

export const TeaserCardsLine = ({
  cards,
  config: {
    common: { backNavigation, scrollBackward, scrollForward },
  },
  header,
  id,
  title,
}: Props) => {
  const teaserCards = (cards || []).map(card => {
    const { seeMoreUrl, title: cardtitle, ...rest } = card;
    const link = {};
    if (seeMoreUrl) {
      link.url = seeMoreUrl;
    }
    return {
      ...rest,
      title: cardtitle,
      link,
      trackingData: {
        actionGA: title,
        labelGA: title,
      },
    };
  });

  return (
    <SiteContainer className="Line" id={id}>
      <LineTitle>{title}</LineTitle>
      <TeaserCards
        backNavigationLabel={backNavigation}
        cards={teaserCards}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
        sliderQueryName={camelCasify(header)}
      />
    </SiteContainer>
  );
};
